import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from '../../component/Footer';
import LoadingSpinner from '../../components/common/LoadingSpinner';

// Lazy load ALL pages — Home is the heaviest (40 images + GSAP) so it benefits most
const Home = lazy(() => import('../root/Home'));
const Contact = lazy(() => import('../root/Contact'));
const Support = lazy(() => import('../root/Support'));
const TermsAndConditions = lazy(() => import('../root/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('../root/PrivacyPolicy'));
const BlogList = lazy(() => import('../blog/BlogList'));
const BlogDetail = lazy(() => import('../blog/BlogDetail'));
const Pricing = lazy(() => import('../root/Pricing'));
const Refundsandcancellationpolicy = lazy(() => import('../root/Refundsandcancellationpolicy'));
const Download = lazy(() => import('../download/index'));
const PageNoFund = lazy(() => import('../root/PageNoFund'));
const Login = lazy(() => import('../app/login'));
const OurCompany = lazy(() => import('../about/OurCompany'));
const OurExperts = lazy(() => import('../about/OurExperts'));
const Overview = lazy(() => import('../Services/Overview'));
const Personal = lazy(() => import('../Services/Personal'));
const Corporate = lazy(() => import('../Services/Corporate'));
const Plans = lazy(() => import('../Plans'));
const Clientele = lazy(() => import('../Clientele'));
const ContactTBL = lazy(() => import('../root/ContactTBL'));

// Shared page loading wrapper
const PageLoader = ({ children }) => (
    <Suspense fallback={
        <div className="page-loader">
            <LoadingSpinner size="large" text="Loading..." />
        </div>
    }>
        {children}
    </Suspense>
);

export default function Router() {
    return (
        <BrowserRouter basename='/'>
            <Routes>
                <Route path='/' element={<PageLoader><Home /></PageLoader>} />
                <Route path='/about/our-company' element={<PageLoader><OurCompany /></PageLoader>} />
                <Route path='/about/our-experts' element={<PageLoader><OurExperts /></PageLoader>} />
                <Route path='/services/overview' element={<PageLoader><Overview /></PageLoader>} />
                <Route path='/services/individuals' element={<PageLoader><Personal /></PageLoader>} />
                <Route path='/services/companies' element={<PageLoader><Corporate /></PageLoader>} />
                <Route path='/plans' element={<PageLoader><Plans /></PageLoader>} />
                <Route path='/clientele' element={<PageLoader><Clientele /></PageLoader>} />
                <Route path='/contact' element={<PageLoader><Contact /></PageLoader>} />
                <Route path='/app/login' element={<PageLoader><Login /></PageLoader>} />
                <Route path='/support' element={<PageLoader><Support /></PageLoader>} />
                <Route path='/pricing' element={<PageLoader><Pricing /></PageLoader>} />
                <Route path='/blog' element={<PageLoader><BlogList /></PageLoader>} />
                <Route path='/blog/:title' element={<PageLoader><BlogDetail /></PageLoader>} />
                <Route path='/terms-and-conditions' element={<PageLoader><TermsAndConditions /></PageLoader>} />
                <Route path='/privacy-policy' element={<PageLoader><PrivacyPolicy /></PageLoader>} />
                <Route path='/download' element={<PageLoader><Download /></PageLoader>} />
                <Route path='/refunds-and-cancellation-policy' element={<PageLoader><Refundsandcancellationpolicy /></PageLoader>} />
                <Route path='/contact-us' element={<PageLoader><ContactTBL /></PageLoader>} />
                <Route path='/*' element={<PageLoader><PageNoFund /></PageLoader>} />
            </Routes>
            <Footer />
        </BrowserRouter>
    )
}
